import React from 'react'
import { Line } from 'rc-progress'
import LinesEllipsis from 'react-lines-ellipsis'
import { CURRENT_METRIC_UPDATED } from '../query/metric'

class FullComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: this.updateMetricStructure(props.metrics)
    }
  }

  componentWillReceiveProps (nextProps) {
    // Update state when latestMetrics prop changes (from polling)
    if (nextProps.metrics !== this.props.metrics) {
      this.setState({
        data: this.updateMetricStructure(nextProps.metrics)
      })
    }
  }

  updateMetricStructure (metrics) {
    const allTrbIds = this.props.sensorIds
    const sumVehicle = allTrbIds.length
    let sumFullVehicle = 0
    metrics.forEach(function (element, key) {
      if (element.metadata && element.value >= ((element.metadata.tank_capacity * 75) / 100)) {
        sumFullVehicle++
      }
    })
    return {
      sumFullVehicle,
      sumVehicle,
      percent: sumVehicle === 0
        ? 0
        : Math.round((sumFullVehicle / sumVehicle) * 100)
    }
  }

  render () {
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='PLEIN'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.content}>
            <p style={styles.number}>{this.state.data.percent}<span style={styles.percent}>%</span></p>
          </div>
          <div style={styles.vehicleNumberContent}>
            <span style={styles.vehicleNumber}>{this.state.data.sumFullVehicle} vehicules/{this.state.data.sumVehicle}</span>
            <Line style={styles.line} percent={this.state.data.percent} strokeWidth='1' strokeColor='#7ED321' />
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  content: {
    textAlign: 'center',
    width: '100%',
    height: '80px',
    marginTop: '98px'
  },
  number: {
    fontSize: '70px',
    color: '#7ED321',
    fontWeight: 'bold'
  },
  percent: {
    fontSize: '30px',
    color: '#7ED321',
    fontWeight: 'bold'
  },
  vehicleNumberContent: {
    marginTop: '80px',
    paddingTop: '4px',
    textAlign: 'center',
    width: '100%',
    height: '28px'
  },
  vehicleNumber: {
    fontSize: '15px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  },
  line: {
    marginLeft: '24px',
    marginRight: '24px'
  }
}

export default FullComponent
